import { render, staticRenderFns } from "./binset-edit-modal.vue?vue&type=template&id=65aa2a3b"
import script from "./binset-edit-modal.vue?vue&type=script&lang=js"
export * from "./binset-edit-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports